export default __webpack_public_path__ + "static/media/LEMONMILK-Regular.55fc2431.otf";